export const communityProjects = [
  {
    title: "EmpowerED",
    features: [
      "Upcoming Events Calendar: A calendar showcasing all future events, with details for easy planning.",
      "Newsletter Subscription: Visitors can subscribe to the newsletter for regular updates on EmpowerED activities and opportunities.",
      "Sponsor Us Page: A dedicated page where potential sponsors can learn about EmpowerED's mission, sponsorship opportunities, and how they can support future initiatives.",
      "ADD MORE"
    ],
    techStack: ["React", "Tailwind CSS", "HTML & CSS", "JavaScript", "GitHub", "Vercel"],
    images: [
      "/community_project_images/Empowered1.png",
      "/community_project_images/Empowered2.png",
      "/community_project_images/Empowered3.png",
      "/community_project_images/Empowered4.png"
    ],
    links: {
      github: "https://github.com/empowerEDu/EmpowerED",
      website: "https://empower-ed.ca/"
    }
  },
  {
    title: "NomNom",
    features: [
      "Disguised UI as a Bakery Ordering App to mask its true purpose and ensure discreet use in unsafe environments.",
      "Emergency Quick-Exit Functionality that redirects users to a neutral page or closes the app instantly.",
      "Hidden Safety Features such as emergency contacts, resource links, and evidence-logging disguised as food orders.",
      "Secure Communication Tools enabling users to discreetly signal for help without drawing attention.",
      "User-Centred, Trauma-Informed Design built with input from domestic violence prevention best practices.",
      "Grant-Backed Development funded by the DMZ x myBlueprint Micro Tech Grant, highlighting real-world recognition and impact."
    ],
    techStack: ["React Native", "Tailwind CSS", "Node.js", "Express", "MongoDB", "AWS APIs & Services", "Figma"],
    images: [
      "/community_project_images/nomnom1.png",
      "/community_project_images/nomnom2.png",
      "/community_project_images/nomnom3.png",
      "/community_project_images/nomnom4.png",
      "/community_project_images/nomnom5.png",
      "/community_project_images/nomnom6.png",
      "/community_project_images/nomnom7.png"
    ],
    links: {
      demo: "https://youtu.be/j03ZX847f54?si=D8GfdEQiNh1iie3T",
    }
  },
  {
    title: "Better Angels LA Shelter Management System",
    features: [
      "Reporting Module: Building data visualizations and occupancy/utilization charts for a shelter bed management platform supporting Better Angels' work serving the unhoused population in Los Angeles.",
      "Real-Time Analytics: Developed analytics and reporting tools giving shelter operators real-time visibility into bed utilization across their network.",
      "Cross-Functional Collaboration: Worked with product, design, and nonprofit stakeholders in an agile environment to ship features supporting real community-impact operations.",
      "Open-Source Nonprofit Platform: Contributed to a monorepo covering mobile and web apps plus backend services, licensed under AGPL to keep the codebase free and open for the community."
    ],
    techStack: ["React Native", "Expo", "TypeScript", "Django", "Python"],
    images: [
      // Add image paths here, e.g. "/community_project_images/betterangels1.png"
    ],
    links: {
      github: "https://github.com/BetterAngelsLA/monorepo"
    }
  }
];